module.exports = __webpack_public_path__ + "img/pic06.17f4b350.jpg";